module.exports = __webpack_public_path__ + "img/disable_512x512.e66ddebb.png";